<template>
  <svg
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2294_242)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.1818 30.3029C14.7879 30.3029 12.1212 32.9695 12.1212 36.3635V181.818C12.1212 185.212 14.7879 187.879 18.1818 187.879H163.636C167.03 187.879 169.697 185.212 169.697 181.818V96.9695C169.697 93.5756 172.364 90.9089 175.758 90.9089C179.152 90.9089 181.818 93.5756 181.818 96.9695V181.818C181.818 191.879 173.697 200 163.636 200H18.1818C8.12121 200 0 191.879 0 181.818V36.3635C0 26.3029 8.12121 18.1816 18.1818 18.1816H103.03C106.424 18.1816 109.091 20.8483 109.091 24.2422C109.091 27.6362 106.424 30.3029 103.03 30.3029H18.1818Z"
        :fill="`url(#paint0_linear_2294_242${props.id})`"
      />
      <path
        d="M193.576 12.7273L187.273 6.42427C178.667 -2.18179 164.485 -2.18179 155.879 6.42427L153.939 8.36367L73.8182 88.4849L65.5758 123.273L76.4849 134.303L111.394 126.061L191.515 45.9394L193.455 44C202.061 35.394 202.061 21.3334 193.455 12.6061L193.576 12.7273ZM162.061 17.0909C162.061 17.0909 163.152 16 163.636 15.5152C165.576 13.5758 167.879 12.3637 170.545 12.2425C173.576 12 176.606 13.0909 178.788 15.2728L184.727 21.2121C188.849 25.3334 188.727 32.1212 184.727 36.2425L182.909 38.0606L176.97 44L156.121 23.1515C158.182 21.0909 160.121 19.1515 162.182 17.0909H162.061ZM105.455 115.394L80.2425 121.333L78.5455 119.636L84.4849 94.4243L86.3031 92.6061L107.152 113.455L105.333 115.273L105.455 115.394ZM93.697 85.4546L148.849 30.3031L169.697 51.1515L114.545 106.303L93.697 85.4546Z"
        fill="inherit"
      />
    </g>
    <defs>
      <linearGradient
        :id="'paint0_linear_2294_242' + props.id"
        x1="44.8485"
        y1="186.545"
        x2="136.848"
        y2="31.8786"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.05"
          stop-color="#FFC83E"
        />
        <stop
          offset="0.45"
          stop-color="#F536CA"
        />
        <stop
          offset="0.95"
          stop-color="#1799E1"
        />
      </linearGradient>
      <clipPath id="clip0_2294_242">
        <rect
          width="200"
          height="200"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
const props = defineProps({
  id: { type: String, required: true },
})
</script>
